import { forwardRef, useMemo, type SelectHTMLAttributes } from 'react'

import { supportedTimeZones } from '@/lib/timezone'
import { Select } from '../primitives/input'

const PREFERRED = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Toronto',
  'Europe/London',
  'UTC',
]

/** IANA timezone picker: common US zones first, then everything the runtime supports. */
export const TimezoneSelect = forwardRef<
  HTMLSelectElement,
  Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'>
>(function TimezoneSelect(props, ref) {
  const options = useMemo(() => {
    const all = supportedTimeZones()
    const preferred = PREFERRED.filter((z) => all.includes(z))
    const rest = all.filter((z) => !preferred.includes(z))
    return [...preferred, ...rest].map((zone) => ({ value: zone, label: zone.replace(/_/g, ' ') }))
  }, [])
  return <Select ref={ref} options={options} placeholder="Choose a timezone…" {...props} />
})
